var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { NOT_LOADED } from "../Infra/RemoteData";
import { unslugifyOptional } from "healthex-common/utils";
import { StudyTranslationLanguage } from "healthex-common/study.dtos";
export class PatientConsentEnrollmentCustomSectionsViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.routingUIManager = container.routingUIManager;
    }
    get additionalSectionIndex() {
        var _a;
        let parts = [];
        if (this.isPreview && this.patientConsentUIManager.session.currentInteractivePreviewRoute) {
            parts = this.patientConsentUIManager.session.currentInteractivePreviewRoute.split("_");
        }
        else {
            const rawStep = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.step;
            const step = unslugifyOptional(rawStep);
            if (!step)
                return null;
            parts = step.split("_");
        }
        return +parts[parts.length - 1] - 1;
    }
    get additionalSection() {
        var _a;
        if (this.additionalSectionIndex === null)
            return null;
        if (this.study === NOT_LOADED || !((_a = this.study) === null || _a === void 0 ? void 0 : _a.additionalSections))
            return null;
        const currentLanguage = this.patientConsentUIManager.currentLanguage;
        let studyLanguage = StudyTranslationLanguage.en;
        switch (currentLanguage) {
            case "es":
                studyLanguage = StudyTranslationLanguage.es;
                break;
            case "en":
            default:
                studyLanguage = StudyTranslationLanguage.en;
                break;
        }
        const filteredAdditionalSections = this.study.additionalSections.filter((additionalSection) => !!additionalSection.included &&
            additionalSection.title.trim().length &&
            additionalSection.description.trim().length &&
            additionalSection.language === studyLanguage);
        return filteredAdditionalSections[this.additionalSectionIndex];
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentEnrollmentCustomSectionsViewModel.prototype, "additionalSectionIndex", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentEnrollmentCustomSectionsViewModel.prototype, "additionalSection", null);
